// 表示存储对象  栈队列 在全局挂载队列
window.stack = [];

export default {

	// 名称
    name: 'clickoutside',

	// 表示时间
	events: {

        bind (el, binding, vnode) {
            function documentHandler (e) {
                if (el.contains(e.target)) {
                    return false;
                }
                if (binding.expression) {
                    binding.value(e);
                    // 点击其他的地方 清空栈
                    window.stack = [];
                }
            }
            el.__vueClickOutside__ = documentHandler;
            document.addEventListener('click', documentHandler);
        },

        update (el, binding) {
          
            // 判断是否关闭
            if (el.innerHTML.indexOf('display: none') === -1) return false;

            // // 判断如果是子元素变更 引发的更新直接忽略
            if (el.innerText !== '') return false;

            let ele = null;
            // 使用栈型结构  添加之前 先删除
            while(ele = window.stack.pop()) {
                ele.value();
            }

            // 待执行事件入栈
            window.stack.push(binding);
        },
        inserted () {

        },
        unbind (el, binding) {
            document.removeEventListener('click', el.__vueClickOutside__);
            delete el.__vueClickOutside__;
        }
	}
};


// WEBPACK FOOTER //
// ./src/directive/ClickOutside/index.js